/**
 * First-visit welcome state.
 *
 * The welcome screen is shown once per device to signed-out visitors, and is
 * always available again at `/welcome`. The flag is a single local value — no
 * account, cookie or server state is involved.
 */

const KEY = "vitolier_welcome_seen";

export function hasSeenWelcome(): boolean {
  if (typeof window === "undefined") return true;
  try {
    return window.localStorage.getItem(KEY) === "1";
  } catch {
    // Storage unavailable (private mode): never trap the visitor on welcome.
    return true;
  }
}

export function markWelcomeSeen() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(KEY, "1");
  } catch {
    // ignore
  }
}

/** Support/QA helper: show the welcome screen again on this device. */
export function resetWelcome() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
